// extracted by mini-css-extract-plugin
export default {"hintLabel":"Comment_hintLabel__b-c3W"};